export const global = {
	REMOVE_USER: 'global/removeUser',
};

export const app = {
	LOADING: 'app/loading',
	ERROR: 'app/error',
	NOT_FOUND: 'app/notFound',
	CHANGE_THEME: 'app/changeTheme',
};

export const articles = {
	FETCH_ARTICLES: 'articles/fetchAll',
	END_ARTICLES: 'articles/end',
	GET_ARTICLES: 'articles/getAll',
	ADD_ARTICLE: 'articles/add',
	EDIT_ARTICLE: 'articles/edit',
	ADD_VIEWS: 'articles/addViews',
	REMOVE_ARTICLE: 'articles/remove',
	ADD_COMMENT: 'articles/comments/add',
	REMOVE_COMMENT: 'articles/comments/remove',
};

export const auth = {
	LOGIN: 'auth/login',
	REGISTER: 'auth/register',
	VERIFY: 'auth/verify',
	LOGOUT: 'auth/logout',
};
export const door = {
	UNLOCK: 'door/unlock',
};
